export enum Constants {
  BrandName = "QR Mark",
}
export enum AddInsConstants {
  CustomPropertyKey = "qrmark_document_id",
}
